<template>
	<page>
		<module :title="id ? '编辑多件优惠购活动' : '新建多件优惠购活动'">
			<c-form ref="form">
				<c-form title="基础信息">
					<c-form-item type="input" label="活动名称" name="activity_name"  maxlength="20" required></c-form-item>
					<c-form-item type="datetime" label="活动时间" start-name="start_time" end-name="end_time" required></c-form-item>
					<c-form-item type="input" label="活动标签" name="tags"  maxlength="12"></c-form-item>
                    <c-form-item type="checkbox" label="可售范围" name="visible_user_type" :options="userLevelOptions" required
                                 word="选中则表示该等级会员可以享受当前活动优惠"></c-form-item>
				</c-form>
                <c-form title="优惠配置">
                    <c-form-item type="radio" label="是否循环计算" name="cycle_rule" :options="cycleRuleOption"  required word="例如设置第1件原价，第2件1元。如选是进行循环计算优惠，则第3件原价，第4件1元；如选否不循环，则超出部分原价销售）"></c-form-item>
                    <c-form-item label="优惠件数配置" required>
                        <m-operate>
                            <c-button color="gray" hollow @click="addTpRule">添加配置</c-button>
                            <div class="c-form-item-word" style="margin-top: 0px !important;margin-left: 15px;">注：优惠配置项必须填写完整，不在优惠配置项内时，将按照原价销售；当权益类型为指定折扣时，折扣权益值最小值可为0折，最大需小于10折。</div>
                        </m-operate>

                        <c-table ref="ruleList" v-model="ruleList" height="315" :paging="false" border>
                            <c-table-column
                                    label="第X件"
                                    name="step_seq"
                                    width="60"
                            >
                                <template v-slot="{data}">
                                    第{{data.step_seq}}件
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="权益类型"
                                    name="benefit_type"
                                    width="160"
                            >
                                <template v-slot="{data}">
                                    <c-form>
                                        <c-form-item label="" v-model="data.benefit_type" type="radio" :options="benefitTypeOption"  style="width: 60%;margin-bottom: 0px !important;"></c-form-item>
                                    </c-form>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="权益值"
                                    name="benefit_value"
                                    width="140"
                            >
                                <template v-slot="{data}">
                                    <c-form v-if="data.benefit_type == 1">
                                        <c-form-item label="" v-model="data.benefit_value" type="number" style="width: 60%;margin-bottom: 0px !important;" decimal="2" inputUnit="元"></c-form-item>
                                    </c-form>
                                    <c-form v-if="data.benefit_type == 2">
                                        <c-form-item label="" v-model="data.benefit_value" type="number" style="width: 60%;margin-bottom: 0px !important;"  decimal="2" inputUnit="折"></c-form-item>
                                    </c-form>
                                    <c-form v-if="data.benefit_type == 3">
                                        <div style="margin-left: 10px;">不打折</div>
                                    </c-form>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="140"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
				<c-form title="活动商品">
					<c-form-item>
						<m-operate>
							<c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
						</m-operate>
						
						<c-table ref="productList" v-model="productList" height="500" :paging="false" border>
							<c-table-column
								label="商品信息"
								name="product_name"
								width="200"
							>
								<template v-slot="{data}">
									<div class="flex-center">
										<c-image :src="data.product_img_url" size="46" preview></c-image>
										<p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
									</div>
								</template>
							</c-table-column>
							
							<c-table-column
								label="所属类目"
								name="product_type_full_name"
							></c-table-column>
							
							<c-table-column
								label="售价"
								name="product_price"
								width="80"
							>
								<template v-slot="{data}">￥{{data.product_price}}</template>
							</c-table-column>
							
							<c-table-column
								label="商品库存"
								name="stock_count"
								width="80"
							></c-table-column>

							<c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="140"
							>
								<template v-slot="row">
									<c-table-button @click="row.remove()">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
				</c-form>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(1)">确定提交</c-button>
			</template>
		</module>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
  </page>
</template>

<script>
	import productSelector from '@/components/service/product_selector.vue'
	
	export default {
		name: 'activity_tp_edit',
		
		components: {
			productSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
                userLimitTypeOption: [{
                    name: '无限制',
                    value: 0
                }, {
                    name: '每人限买N件',
                    value: 1
                }],
                stateOption: [{
                    name: '否',
                    value: 0
                }, {
                    name: '是',
                    value: 1
                }],
				cycleRuleOption: [{
					name: '否',
					value: 0
				}, {
					name: '是',
					value: 1
				}],
                benefitTypeOption: [{
                    name: '固定金额',
                    value: 1
                }, {
                    name: '指定折扣',
                    value: 2
                },{
                    name: '不打折',
                    value: 3
                }],
                userLimitType:0,
                userLimitValue:'',
                ruleList: [],
				productList: [],
                userLevelOptions: []
            }
		},
		watch: {
			id() {
				this.getActivityTpDetail();
			},
			
			commodityRange(val) {
				if (val == 2) {
					this.$refs.productList.resize();
				}
			},

		},
		
		mounted() {
            this.initUserLevelOptions();
            this.$nextTick(() => {
                this.tableRendered = true;
                if (this.id) {
                    this.getActivityTpDetail();
                }
            });
		},
		
		methods: {
            //加载会员等级列表
            initUserLevelOptions(){
                this.request({
                    url: '/user_level/options',
                    data: {},
                    success: data => {
                        this.userLevelOptions = Array.from(data, item => {
                            return {
                                name: item.name,
                                value: item.value
                            }
                        });
                    }
                });
            },

			getActivityTpDetail() {
				this.request({
					url: '/activityTp/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						this.userLimitType = data.user_limit_type;
                        this.userLimitValue = data.user_limit_value;
                        var seq=1;
                        this.ruleList = data.rule_list.map(item => {
                            return {
                                step_seq: seq++,
                                min_count: item.min_count,
                                max_count: item.max_count,
                                benefit_type: item.benefit_type,
                                benefit_value: item.benefit_value.toString() ,
                            }
                        });
						this.productList = data.product_list;
					}
				});
			},
            addTpRule(){
                if(this.ruleList.length > 5){
                    this.$message({
                        text: '最多添加5个配置'
                    });
                    return;
                }
                var stepSeq = this.ruleList.length + 1;
                var minCount =1 ;
                var maxCount = 1;
                var benefitType = 1;
                var benefitValue = '';
                if(this.ruleList.length > 0){
                    var lastRule=this.ruleList[this.ruleList.length-1];
                    if(lastRule.benefit_type==3){
                        lastRule.benefit_value=10;
                    }
                    if(!lastRule.benefit_value){
                        this.$message({
                            text: '请先填写上一配置权益值'
                        });
                        return;
                    }
                    stepSeq = lastRule.step_seq + 1;
                    minCount = stepSeq;
                    maxCount = stepSeq;
                }
                this.ruleList.push({
                    step_seq: stepSeq,
                    min_count:minCount,
                    max_count:maxCount,
                    benefit_type:benefitType,
                    benefit_value:benefitValue
                });
                this.ruleList = this.ruleList.sort((a,b) => {return a.step_seq - b.step_seq>0 ? 1:-1});
            },
			productSelectHandle(list) {
			    if(list){
                   //默认赠品1件
                   list.forEach(gift => {
                       gift.count = 1;
                   });
                }
				if (this._gift) {
					this._gift.forEach(row => {
						row.update({
							gift_list: list
						});
					});
					delete this._gift;
				} else {
					list = list.filter(item => {
						return !this.productList.find(row => {
							return row.product_id == item.product_id;
						});
					});
					this.productList = this.productList.concat(list);
				}
			},
			submit() {
				this.$refs.form.submit({
					url: this.id ? '/activityTp/edit' : '/activityTp/add',
					rule: {
						activity_name: '请填写活动名称',
						start_time: '请选择活动时间',
                        end_time: '请选择活动时间',
                        visible_user_type: '请选择活动可售范围',
                        rule_list: [{
                            type: 'function',
                            fun: () => {
                                return this.ruleList.length;
                            },
                            word: '请添加优惠配置'
                        }],
                        rule_list_check: [{
                            type: 'function',
                            fun: this.ruleListCheck,
                            word: '优惠件数配置有误，请检查'
                        }],
						product_list: [{
							type: 'function',
							fun: () => {
								return this.productList.length;
							},
							word: '请选择活动商品'
						}],
					},
					
					dataFormatter: data => {
						if(this.id){
                            data.id = this.id;
                        }
                        data.visible_user_type = data.visible_user_type?data.visible_user_type.join(','):'';
                        data.rule_list = this.ruleList;
                        data.product_list = this.productList;
                        //用户限制类型（0-无限制 1-每人限买N件） 暂未使用，故传默认值
                        data.user_limit_type = 0;
                        //叠加规则：0-不与其他活动叠加,其他待扩展 暂未使用，故传默认值
                        data.combin_rule = 0;
						return data;
					},
					
					success: () => {
						this.$message({
							text: '保存成功'
						});
                        this.$bus.$emit('activityTpList.update', {});
						this.redirectTo('/activity_tp_list');
					}
				})
			},
            ruleListCheck(){
                var check=true;
                for(var i=0;i<this.ruleList.length;i++){
                    var item=this.ruleList[i];
                    if(item.benefit_type==3){
                        item.benefit_value = 10;
                        this.ruleList[i].benefit_value = 10;
                    }
                    if(!item.benefit_value || item.benefit_value<0){
                        check= false;
                    }

                    if(item.benefit_type==2 && item.benefit_value>=10){
                        check= false;
                    }
                    const benefitValueNum = parseFloat(item.benefit_value);
                    if(isNaN(benefitValueNum)) {
                        check = false;
                    }

                    this.ruleList[i].min_count=item.step_seq;
                    this.ruleList[i].max_count=item.step_seq;
                }
                return check;
            },
		}
	}
</script>

<style lang="stylus" scoped>
	.limit {
		.item {
			margin-right: 16px;
			label {
				margin-right: 8px;
			}
		}
	}
</style>